import React, { useEffect, useState } from "react";
import "./homeProductDetails.css";
import axiosInstance from "../../apis/config";
import { Link, useNavigate } from "react-router-dom";
import StarRating from "./starRating";

const HomeProductDetails = () => {
  const [products, setProducts] = useState([]);
  const [showSpinner, setShowSpinner] = useState(true);
  const [randomProduct, setRandomProduct] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    setShowSpinner(true);
    axiosInstance
      .get("/products", {})
      .then((response) => {
        setProducts(response.data.data);
        setShowSpinner(false);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  useEffect(() => {
    if (products.length > 0) {
      const randomIndex = Math.floor(Math.random() * products.length);
      setRandomProduct(products[randomIndex]);
    }
  }, [products]);

  function getRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  const goToProducts = () => {
    navigate(`/product-details/${randomProduct._id}`);
  };

  return (
    <div className="container">
      {showSpinner ? (
        <>
          <h2 className="title m-2 he-headers">
            <span>Deal</span> of the Day in Nakuru
          </h2>
          <div className="product-featured border rounded p-5">
            <p className="placeholder-glow">
              <span className="placeholder col-12"></span>
              <span className="placeholder col-12"></span>
              <span className="placeholder col-12"></span>
            </p>
            <p className="placeholder-wave">
              <span className="placeholder col-12"></span>
              <span className="placeholder col-12"></span>
            </p>{" "}
          </div>
        </>
      ) : (
        <div className="product-featured">
          {randomProduct && (
            <h2 className="title m-2 he-headers">
              <span>Daily Security Deal</span> in Nakuru
            </h2>
          )}
          {randomProduct && (
            <div
              className="showcase-wrapper has-scrollbar"
              itemScope
              itemType="https://schema.org/Product"
            >
              <meta itemProp="sku" content={randomProduct._id} />
              <meta
                itemProp="category"
                content={randomProduct.category?.name || "Security Products"}
              />
              <meta
                itemProp="brand"
                content={randomProduct.brand || "Nakuru Security Solutions"}
              />

              <div className="showcase-container">
                <div className="showcase">
                  <div className="showcase-banner">
                    <img
                      src={randomProduct.documents[0]?.url}
                      alt={`${randomProduct.name} security deal in Nakuru, Kenya`}
                      className="showcase-img"
                      itemProp="image"
                    />
                  </div>

                  <div className="showcase-content">
                    <div
                      className="d-flex"
                      style={{ marginBottom: 0 }}
                      itemProp="aggregateRating"
                      itemScope
                      itemType="https://schema.org/AggregateRating"
                    >
                      <meta
                        itemProp="ratingValue"
                        content={randomProduct.ratings}
                      />
                      <meta
                        itemProp="reviewCount"
                        content={randomProduct.reviews?.length || 1}
                      />
                      <p className="mb-0">
                        <StarRating
                          rating={randomProduct.ratings}
                          className="mb-0"
                          style={{ marginBottom: 0 }}
                        />
                      </p>
                      <p style={{ marginLeft: "5px", fontSize: "12px" }}>
                        ({randomProduct.reviews?.length}) reviews
                      </p>
                    </div>

                    <Link to={`/product-details/${randomProduct._id}`}>
                      <h3 className="showcase-title" itemProp="name">
                        {randomProduct.name}
                      </h3>
                    </Link>

                    <p
                      className="showcase-desc"
                      dangerouslySetInnerHTML={{
                        __html: randomProduct.description.slice(0, 300) + "...",
                      }}
                      itemProp="description"
                    ></p>

                    <div
                      className="price-box"
                      itemProp="offers"
                      itemScope
                      itemType="https://schema.org/Offer"
                    >
                      <meta itemProp="priceCurrency" content="KES" />
                      <meta itemProp="price" content={randomProduct.price} />
                      <meta
                        itemProp="itemCondition"
                        content="https://schema.org/NewCondition"
                      />
                      <meta
                        itemProp="availability"
                        content="https://schema.org/InStock"
                      />

                      <p className="price" itemProp="price">
                        sh. {randomProduct.price.toLocaleString()}
                      </p>

                      <del>
                        sh.{" "}
                        {(
                          (randomProduct.discount / 100) * randomProduct.price +
                          randomProduct.price
                        ).toLocaleString()}
                      </del>
                    </div>

                    <button
                      onClick={() => goToProducts()}
                      className="add-cart-btn"
                      aria-label="View this security product deal details"
                    >
                      see more
                    </button>

                    <div className="showcase-status">
                      <div className="wrapper">
                        <p>
                          already sold: <b>{getRandomNumber(5, 20)}</b>
                        </p>

                        <p>
                          available: <b>{getRandomNumber(20, 50)}</b>
                        </p>
                      </div>

                      <div className="showcase-status-bar"></div>
                    </div>

                    <div className="countdown-box">
                      <p className="countdown-desc">Hurry Up! Offer ends in:</p>

                      <div className="countdown">
                        <div className="countdown-content">
                          <p className="display-number">
                            {getRandomNumber(1, 7)}
                          </p>
                          <p className="display-text">Days</p>
                        </div>

                        <div className="countdown-content">
                          <p className="display-number">
                            {getRandomNumber(1, 24)}
                          </p>
                          <p className="display-text">Hours</p>
                        </div>

                        <div className="countdown-content">
                          <p className="display-number">
                            {getRandomNumber(1, 60)}
                          </p>
                          <p className="display-text">Min</p>
                        </div>

                        <div className="countdown-content">
                          <p className="display-number">⌛</p>
                          <p className="display-text">Sec</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default HomeProductDetails;
